export default __webpack_public_path__ + "static/media/checked-green.efb1c2b0.svg";